angular.module('iqxCore')
.controller('SitemapCtrl', function ($scope) {
	var getSiteMapItems = function(){
		//select all items which are not dropdowns and not within dropdown
		$scope.currentMenuItemsNonDropdown = document.querySelectorAll("ul.sidebar-menu > li:not(.treeview) a")
		//select all drop down items
		$scope.currentMenuItemsDropdownItems = document.querySelectorAll(".sidebar-menu > li.treeview")
		//create array siteMapItems
		$scope.siteMapItems = []
		//loop through every non drop down item, add object to siteMapItems for each
		angular.forEach($scope.currentMenuItemsNonDropdown, function(value, key) {
			$scope.siteMapItems.push({title:value.text, link:value.href})
		})
		//loop through every drop down item
		angular.forEach($scope.currentMenuItemsDropdownItems, function(value, key) {
			//create varable for all items in drop dropdown
			var dropDownItems = value.querySelectorAll("ul > li > a:last-child")
			//create varable for title of dropdown
			var dropDownTitle = value.querySelector("a > span")
			//loop through all items inside dropdown
			angular.forEach(dropDownItems, function(dropDownItem, keySub) {
				//add object to siteMapItems for each item in dropdown, passing in the tile for the dropdown and the text for item
				$scope.siteMapItems.push({title:(dropDownTitle.textContent + ": " + dropDownItem.text), link:dropDownItem.href})
			})
		})
	}
	getSiteMapItems()
})
